"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSearchValidSortColumnsEnum = void 0;
var UserSearchValidSortColumnsEnum;
(function (UserSearchValidSortColumnsEnum) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UserSearchValidSortColumnsEnum["id"] = "id";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UserSearchValidSortColumnsEnum["username"] = "username";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UserSearchValidSortColumnsEnum["firstName"] = "firstName";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    UserSearchValidSortColumnsEnum["lastName"] = "lastName";
})(UserSearchValidSortColumnsEnum || (exports.UserSearchValidSortColumnsEnum = UserSearchValidSortColumnsEnum = {}));
